import { Modal } from '@/components/Common/Modal';
import { useTranslate } from '@/hooks/useTranslate';
import rotateYourPhoneImage from '@/assets/icons/common/rotate-your-phone.gif';

export const LandscapeRotateScreen = () => {
  const { t } = useTranslate();

  return (
    <Modal>
      <div
        data-testid="first-time-landscape-rotate-screen"
        className="flex h-[100dvh] w-full flex-col items-center justify-center bg-[#1f1f1f] px-6 text-center text-white"
      >
        <img data-testid="rotate-your-phone-image" src={rotateYourPhoneImage} className="h-30 w-30 object-contain" />
        <p className="text-base font-normal leading-6 text-gray-200">{t('rotateYourPhoneForBestExperience')}</p>
      </div>
    </Modal>
  );
};
